import Api from './api'

import Package from '../../package'

import UserAgent from '../modules/userAgent'

export default {

    has: function () {

        const device = UserAgent.getDevice()

        const version = Package.version

        return Api.get(`/v3/users/feedbacks/given/device/${ device }/version/${ version }`)

    },

    update: function (device, mood, tags = [], message = '') {

        const version = Package.version

        return Api.post('/v3/users/feedbacks', { device, version, mood, tags, message })

    }

}

